import { render } from "./ProductGroupListManager.vue?vue&type=template&id=54bc7f10"
import script from "./ProductGroupListManager.vue?vue&type=script&lang=js"
export * from "./ProductGroupListManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__